module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/bg_equipment-93c1a525af21e8bca4c7bb2cd0654567.png";